<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="create_order">
      <div class="order_body">
        <el-form ref="dataForm"
                 label-width="90px"
                 label-position="left">
          <el-row>
            <el-col :span="7">
              <el-form-item label="用户名：">{{$store.state.user.name}}</el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="订单来源：">
                <!-- {{$t('order.orderSource.' + params.orderSource)}} -->
                {{$getDictLabel("ORDER_SOURCE", params.orderSource)}}
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="采购公司：">{{params.companyName}}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table ref="goodsTable"
                        :data="dataJson.payOrderItemVoList.slice((goodsPage - 1) * 10, goodsPage * 10)"
                        style="width: 906px"
                        size="small"
                        border>
                <el-table-column type="index" width="50" align="center"></el-table-column>
                <el-table-column prop="goodsCode"
                                label="商品编号"></el-table-column>
                <el-table-column prop="goodsName"
                                label="商品名称"></el-table-column>
                <el-table-column prop="brandName"
                                label="品牌"></el-table-column>
                <el-table-column prop="goodsModel"
                                label="型号"
                                width="120"></el-table-column>
                <el-table-column prop="goodsNum"
                                label="数量"
                                width="70"></el-table-column>
                <el-table-column label="折扣率"
                                width="70"
                                v-if="dataJson.promotion !== 1">
                  <template slot-scope="scope">
                    <span :label="scope.row.discount">{{scope.row.discount}}%</span>
                  </template>
                </el-table-column>
                <el-table-column label="单价"
                                width="130"
                                v-if="dataJson.promotion !== 1">
                  <template slot-scope="scope">
                    <span :label="scope.row.goodsPrice"
                          class="discount">{{scope.row.goodsPrice}}</span><br />
                    <span :label="scope.row.goodsPriceDiscount">{{scope.row.goodsPriceDiscount}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="单价"
                                width="130"
                                v-else>
                  <template slot-scope="scope">
                    <span :label="scope.row.goodsPrice">{{scope.row.goodsPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="logisticsTemplate"
                                label="运费规则"
                                width="130">
                  <template slot-scope="scope">
                    {{scope.row.logisticsTemplate}}
                    <span class="deliveryArea" v-show="scope.row.distribution===1">不在配送区域</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="expressFee"
                                label="运费"
                                width="70"></el-table-column> -->
                <el-table-column label="总价"
                                width="130"
                                v-if="dataJson.promotion !== 1">
                  <template slot-scope="scope">
                    <span :label="scope.row.money"
                          class="discount">{{scope.row.money}}</span><br />
                    <span :label="scope.row.goodsMoney">{{scope.row.goodsMoney}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="总价"
                                width="130"
                                v-else>
                  <template slot-scope="scope">
                    <span :label="scope.row.money">{{scope.row.money}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 商品分页 -->
              <el-pagination :current-page="goodsPage"
                          :page-size="10"
                          v-show="dataJson.payOrderItemVoList && dataJson.payOrderItemVoList.length > 10"
                          :total="dataJson.payOrderItemVoList ? dataJson.payOrderItemVoList.length : 0"
                          layout="total, prev, pager, next, jumper"
                          @current-change="changeGoodsPage">
              </el-pagination>
              <!-- 优惠，总金额 -->
              <el-row style="background-color:#ebebeb;">
                <el-col :span="5"
                        :offset="19"
                        style="margin-top:10px">
                  <span>运费：<span style="color:red"><span>￥</span>{{dataJson.expressFee || 0}}</span></span>
                </el-col>
              </el-row>
              <el-row style="background-color:#ebebeb; height:50px"
                      v-if="dataForm.promotion!==1">
                <el-col :span="5"
                        :offset="14"
                        style="margin-top:10px">
                  <span>折扣金额：<span style="color:#333"><span>￥</span>{{dataJson.discountAmount}}</span></span>
                </el-col>
                <el-col :span="5"
                        :offset="0"
                        style="margin-top:10px">
                  <span>总金额：<span style="color:red"><span>￥</span>{{dataJson.payMoney}}</span></span>
                </el-col>
              </el-row>
              <el-row style="background-color:#ebebeb; height:50px" v-else>
                <el-col :span="5"
                        :offset="19"
                        style="margin-top:10px">
                  <span>总金额：<span style="color:red"><span>￥</span>{{dataJson.payMoney}}</span></span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 付款方式 -->
          <el-row style="margin-top:20px">
            <el-col :span="8">
              <font color="red">*</font>
              <span>付款类型：
                <label class="cursor-pointer"><input type="radio" :value="true" name="fullAmount" :label="true" v-model="dataForm.fullAmount">全款发货</label>
                <label v-if="dataForm.contractType === '30'" class="newInput"><input type="radio" :value="false" name="fullAmount" :label="false" class="left-margin" v-model="dataForm.fullAmount" disabled>其他方式</label>
                <label v-else class="cursor-pointer"><input type="radio" :value="false" name="fullAmount" :label="false" class="left-margin" v-model="dataForm.fullAmount">其他方式</label>
              </span>
            </el-col>
          </el-row>
          <!-- 合同模板 -->
          <el-row style="margin-top:20px">
            <el-col :span="12">
              <font color="red">*</font>
              <span>合同模板：
                <label class="newInput"><input type="radio" value="20" name="contractType" label="20" v-model="dataForm.contractType">默认模板</label>
                <label class="newInput"><input type="radio" value="10" name="contractType" label="10" class="left-margin" v-model="dataForm.contractType">自定义模板</label>
                <label class="newInput" v-if="dataForm.fullAmount === false"><input type="radio" value="30" name="contractType" label="30" class="left-margin" v-model="dataForm.contractType" disabled>无需合同,立即购买</label>
                <label v-else class="newInput"><input type="radio" value="30" name="contractType" label="30" class="left-margin" v-model="dataForm.contractType">无需合同,立即购买</label>
              </span>
            </el-col>
          </el-row>
          <el-row class="downloadContract">
            <el-col v-if="dataForm.contractType === '20'" :span="8">
              <span class="checkContract" @click="lookContract">查看合同</span>
              <span class="checkContract" @click="contractDownloadHandle">下载合同</span>
            </el-col>
            <el-col v-show="dataForm.contractType === '10'" :span="16">
              <el-upload :action="actionUrl"
                        :show-file-list="true"
                        :with-credentials="true"
                        :headers="upLoadHeaders"
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload"
                        :data="{ fileSuffixType: 'allType' }"
                        :accept="'.jpg,.jpeg,.png,.gif,.bmp,.doc,.docx,.pdf'"
                        :before-remove="beforeRemove">
                        <!-- :data="IDcardBdata" -->
                <el-button class="upLoad-but"
                          size="small"
                          v-show="!dataForm.contractUrl"
                          icon="el-icon-plus">上传合同</el-button>
              </el-upload>
            </el-col>
          </el-row>
          <!-- 改价 -->
          <el-row style="margin-top:20px" v-if="dataJson.promotion === 1">
            <el-checkbox v-model="dataForm.revisionPrice"
            >要求改价</el-checkbox>
            <el-input style="margin-top:20px"
                      v-show="dataForm.revisionPrice"
                      type="textarea"
                      :maxlength="500"
                      :autosize="{ minRows: 2, maxRows: 4}"
                      placeholder="请输入内容"
                      v-model="dataForm.leaveMsg">
            </el-input>
          </el-row>
          <!-- 地址 -->
          <div class="addressList_oreder">
            <div class="addTitle">
              <div class="addTitle1">收货地址管理:
                <i :class="'cursor-pointer ' + (showAddressVisible? 'el-icon-caret-top': 'el-icon-caret-bottom')"
                   @click="showAddressVisible=!showAddressVisible"></i>
              </div>
              <div class="addTitle2"
                    @click="addAddress"><i>+</i> 新增地址</div>
            </div>
            <el-table
              :data="addressList"
              :show-header="false"
              v-show="showAddressVisible"
              stripe
              style="width: 100%">
              <el-table-column
                label=""
                width="50">
                <template slot-scope="scope">
                  <el-radio v-model="params.addressId"
                            :label="scope.row.userAddressId"
                            @change="addressChangeHandle">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="地址">
                <template slot-scope="scope">
                  <div class="addListInfo1">{{scope.row.receiveGoodsPerson}} {{scope.row.receiveGoodsPhone}}<span v-if="scope.row.defaultAddress" class="default-flag">默认</span></div>
                    <div class="addListInfo2">
                      <div><span class="addListInfo22"></span> {{scope.row.province}}-{{scope.row.city}}-{{scope.row.area}}-{{scope.row.address}}</div>
                    </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="120">
                <template slot-scope="scope">
                  <div class="last_row">
                    <i class="el-icon-edit-outline cursor-pointer" @click="addressEditHandle(scope.row)"></i>
                    <i class="el-icon-delete cursor-pointer" @click="addressDeleteHandle(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 发票 -->
          <div class="invoice_order margin-top">
            <div>发票信息</div>
            <el-table ref="apyTable"
                      :data="payInvoiceInfoList"
                      width="906px"
                      size="small"
                      border
                      highlight-current-row>
              <el-table-column label="选择"
                                center
                                width="50">
                <template slot-scope="scope">
                  <el-radio v-model="dataForm.invoiceInfoId"
                            :label="scope.row.invoiceId"
                            aria-checked="true">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column label="发票抬头"
                                width="200">
                <template slot-scope="scope">
                  <span :label="scope.row.companyName">{{scope.row.companyName}}</span>
                  <span v-if="scope.row.defaultFlag === '10'"
                        class="default-flag"
                  >默认</span>
                </template>
              </el-table-column>
              <el-table-column prop="taxpayerIdentity"
                               label="税务登记证号"
                               width="200"></el-table-column>
              <el-table-column prop="bankAccountNo"
                               label="基本开户账号"
                               width="200"></el-table-column>
              <el-table-column prop="companyPhone"
                               label="固定电话"
                               width="150"></el-table-column>
              <el-table-column prop="openingBank"
                               label="开户银行名称"
                               width="200"></el-table-column>
              <el-table-column prop="companyAddress"
                               label="注册场所地址"
                               width="200"></el-table-column>
              <el-table-column label="操作"
                               width="100">
                <template slot-scope="scope">
                  <el-button @click="invoiceEditHandle(scope.row)"
                              type="text"
                              :loading="buttonLoading"
                              size="small">编辑</el-button>
                  <el-button @click="invoiceDeleteHandle(scope.row)"
                              type="text"
                              :loading="buttonLoading"
                              size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 新增发票 -->
            <el-row class="margin-top">
              <el-col :span="24" style="text-align: right;">
                <div class="addBut"
                     @click="invoiceAddHandle"><i>+</i> 新增发票</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span>备注信息：</span>
                <el-input type="textarea"
                          :rows="4"
                          placeholder="请输入备注"
                          v-model="dataForm.orderRemarks"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="user-row center-content"
             style="text-align:center;margin-top:20px">
          <button class="not-in-distribution"
                  v-show="!distributionFlag"
                  disabled>不在配送区域内</button>
          <button class="save-but"
                  :loading="buttonLoading"
                  v-show="distributionFlag && dataJson.payOrderItemVoList.length"
                  @click="submit">提交订单</button>
        </div>
      </div>
    </div>
    <!-- 编辑收货地址 -->
    <el-dialog title="收货地址"
               :visible.sync="editAddressVisible"
               width="1190px"
               :before-close="handleClose2">
      <div class="addArea"
            v-if="editAddressInfo">
        <h2 class="addTitle">编辑收货地址</h2>
        <div class="add_form">
          <el-form ref="editAddressInfo"
                   label-width="198px"
                   :model="editAddressInfo"
                   :rules="addressRule"
                   :disabled="buttonLoading"
                   label-position="right">
            <el-form-item label="地址信息：" prop="proCityArea">
              <el-cascader :options="region"
                          clearable
                          :placeholder="
                            (editAddressInfo.proCityArea &&
                              editAddressInfo.proCityArea.join(' / ')) ||
                            '请选择'
                          "
                          :props="props"
                          class="input_width"
                          v-model="editAddressInfo.proCityArea"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
              <el-input v-model="editAddressInfo.address"
                        placeholder="请输入详细地址"
                        :maxlength="200"></el-input>
            </el-form-item>
            <el-form-item label="收货人姓名：" prop="receiveGoodsPerson">
              <el-input v-model="editAddressInfo.receiveGoodsPerson"
                        class="input_width"
                        placeholder="请输入收货人姓名"
                        :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="receiveGoodsPhone">
              <div class="last_row">
                <el-input v-model="editAddressInfo.receiveGoodsPhone"
                          class="input_width"
                          placeholder="请输入手机号码"
                          :maxlength="50"></el-input>
                <el-checkbox v-model="editAddressInfo.defaultAddress"
                              text-color="#333333"
                              fill="#1D65A8"
                              class="defaultbox">
                  设为默认收货地址
                </el-checkbox>
              </div>
            </el-form-item>
          </el-form>
          <div class="addTitle" style="height: 2px;">&nbsp;</div>
          <div @click="handleAddressSaved"
               class="saveAdd"
               v-loading="buttonLoading">保存地址</div>
        </div>
      </div>
    </el-dialog>
    <!-- 删除提示 -->
    <el-dialog title=""
                :visible.sync="addressDeleteVisible"
                width="30%"
                :before-close="() => {addressDeleteVisible=false}">
      <span>{{$t('message.deleteAddress')}}</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="addressDeleteVisible=false"
                    :loading="buttonLoading">{{$t('cancel')}}</el-button>
        <el-button type="primary"
                    @click="confirmAddDelete"
                    :loading="buttonLoading">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
    <!-- 新增发票弹窗 -->
    <el-dialog title="发票信息"
               :visible.sync="invoiceVisible"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form :model="invoiceForm"
               :rules="invoiceFormRules"
               ref="invoiceForm"
               label-position="right">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发票类型："
                          prop="invoiceType">
              <el-radio-group v-model="invoiceForm.invoiceType">
                <el-radio label="10">普通发票</el-radio>
                <el-radio label="20">专用发票</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票对象："
                          prop="invoiceObjType">
              <el-radio-group v-model="invoiceForm.invoiceObjType">
                <el-radio label="10">个人</el-radio>
                <el-radio label="20">单位</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发票类型："
                          prop="invoiceType">
              <el-checkbox v-model="invoiceForm.flagAdd">
                默认发票
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票抬头"
                          prop="companyName">
              <el-input v-model="invoiceForm.companyName" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务登记证号"
                          prop="taxpayerIdentity">
              <el-input v-model="invoiceForm.taxpayerIdentity"
                        maxlength="50"
                        placeholder=""
                        @input="invoiceForm.taxpayerIdentity=invoiceForm.taxpayerIdentity.replace(/[^A-Za-z0-9]/g,'')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="基本开户账号"
                          prop="bankAccountNo"
                          :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.bankAccountNo : [{ required: false, message: '', trigger: 'blur' }]">
              <el-input v-model="invoiceForm.bankAccountNo" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册固定电话"
                          prop="companyPhone"
                          :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.companyPhone : [{ required: false, message: '', trigger: 'blur' }]">
              <el-input v-model="invoiceForm.companyPhone" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户银行名称"
                          prop="openingBank"
                          :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.openingBank : [{ required: false, message: '', trigger: 'blur' }]">
              <el-input v-model="invoiceForm.openingBank" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册场所地址"
                          prop="companyAddress"
                          :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.companyAddress : [{ required: false, message: '', trigger: 'blur' }]">
              <el-input v-model="invoiceForm.companyAddress" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票收货人"
                          prop="consignee">
              <el-input v-model="invoiceForm.consignee" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票收货人电话"
                          prop="contactInformation">
              <el-input v-model="invoiceForm.contactInformation" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票邮寄地址"
                          prop="mailingAddress">
              <el-input v-model="invoiceForm.mailingAddress" :maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeInviceHandle()"
                   :loading="buttonLoading">取 消</el-button>
        <el-button type="primary"
                   @click="invoiceSaveHandle()"
                   :loading="buttonLoading">保 存</el-button>
      </div>
    </el-dialog>
    <company-add ref="companyAdd" v-if="addCompanyVisible" :jumpRoute="false"></company-add>
  </div>
</template>
<script>
// getDictDataList
import { openOther } from '@/utils'
import debounce from 'lodash/debounce'
// import { isEmail } from '@/utils/validate'
import validate from '@/utils/validate'
import qs from 'qs'
import { getAccessToken } from '@/utils/userInfo'
import CompanyAdd from '@/views/modules/personalCenter/organization/company-add'
export default {
  data () {
    return {
      distributionFlag: false, // 是否在配送区域内
      buttonLoading: false, // 加载中
      // 生成订单参数
      params: {
        orderSource: '',
        shoppingCart: {},
        shoppingCartFormList: [],
        companyId: '',
        companyName: '',
        addressId: '',
        userId: ''
      },
      // 生成订单返回参数
      dataJson: {
        promotion: 1,
        payOrderItemVoList: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      },
      // 表单提交参数
      dataForm: {
        revisionPrice: false, // 是否改价
        leaveMsg: '', // 改价留言
        outStock: '10',
        // orderSource: '', // 订单类型
        // shoppingCart: {}, // 商品列表
        // shoppingCartFormList: [], // 商品列表
        invoiceInfoId: '', // 发票Id
        // addressId: '', // 公司地址id
        contractType: '20', // 合同类型(10 自定义合同,20 默认合同,30 无需合同)
        contractUrl: '', // 合同url
        orderRemarks: '', // 订单备注
        fullAmount: true // 是否全款，false否，true是
      },
      goodsPage: 1,
      // 地址
      region: [],
      props: {
        label: 'name',
        value: 'name',
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node
          // 防止过载
          if (node.loaded) {
            resolve([])
            return
          }
          if (level === 1) {
            // 切换省
            this.getCity(data.codeP)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
          if (level === 2) {
            // 切换市
            this.getArea(data.codeC)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
        }
      },
      addressList: [],
      showAddressVisible: true,
      editAddressVisible: false, // 编辑地址弹框
      editAddressInfo: null,
      addressDeleteVisible: false, // 删除地址弹框
      addressDeleteId: '',
      // 发票
      payInvoiceInfoList: [],
      invoiceVisible: false,
      // 发票对象
      invoiceForm: {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '10', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      },
      // 上传
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      contractIds: [], // 要删除的合同编号
      addCompanyVisible: false // 企业账号 dialog
    }
  },
  computed: {
    addressRule () {
      return {
        proCityArea: [
          { required: true, type: 'array', message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        receiveGoodsPerson: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        receiveGoodsPhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validate.validateMobile, trigger: 'blur' }
        ]
      }
    },
    invoiceFormRules () {
      return {
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxpayerIdentity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankAccountNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    },
    companyId () {
      return this.$store.state.user.defaultCompanyId
    }
  },
  components: {
    CompanyAdd
  },
  mounted () {
    this.addCompanyVisible = false
    this.getProvince()
    this.params.orderSource = this.$route.query.orderSource
    if (this.params.orderSource === '10') {
      // 购物车下单
      this.params.shoppingCartFormList = this.$route.query.shoppingCartFormList ? JSON.parse(this.$route.query.shoppingCartFormList) : ''
    } else if (this.params.orderSource === '20') {
      // 立即下单
      this.params.shoppingCart = this.$route.query.shoppingCart ? JSON.parse(this.$route.query.shoppingCart) : ''
    }
    this.getOrderInfo()
    this.getaddressDataList()
    this.getInvoicList()
  },
  methods: {
    // 获取订单详情
    getOrderInfo () {
      this.payInvoiceInfoList = []
      this.dataJson = {
        promotion: 1,
        payOrderItemVoList: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      }
      this.goodsPage = 1
      this.$http.post(`/front/consumer/order/generateOrder`, this.params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          let data = res.data
          this.params.companyId = data.companyId
          this.params.companyName = data.companyName
          this.params.userId = data.userId
          let addressId = ''
          if (data.sysUserAddressVos && data.sysUserAddressVos.length) {
            let address = data.sysUserAddressVos.find(item => {
              return item.defaultAddress === true
            })
            if (!address) {
              addressId = data.sysUserAddressVos[0].userAddressId
            } else {
              addressId = address.userAddressId
            }
          }
          this.params.addressId = addressId
          this.dataJson = data
          // this.payInvoiceInfoList = this.dataJson.payInvoiceInfoVoList || []
          // this.goodsTableData = data.payOrderItemVoList
          if (data.payOrderItemVoList && data.payOrderItemVoList.length) {
            this.distributionFlag = data.payOrderItemVoList.every(item => {
              // distribution  =2支持  =1 不支持 3面议
              return item.distribution && item.distribution !== 1
            })
          } else {
            this.distributionFlag = false
          }
        })
    },
    changeGoodsPage (page) {
      this.goodsPage = page
    },
    // 更改选中的地址
    addressChangeHandle (addressId) {
      // console.log(addressId)
      // if (this.params.addressId !== addressId) {
      this.params.addressId = addressId
      this.refushOrder()
      // }
    },
    // 由于切换地址造成运费及相关价格改变等
    refushOrder () {
      this.payInvoiceInfoList = []
      this.dataJson = {
        promotion: 1,
        payOrderItemVoList: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      }
      this.goodsPage = 1
      this.$http.post(`/front/consumer/order/generateOrder`, this.params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          let data = res.data
          this.params.companyId = data.companyId
          this.params.companyName = data.companyName
          // if (data.sysUserAddressVos && data.sysUserAddressVos.length) {
          //   let address = data.sysUserAddressVos.find(item => {
          //     console.log(item, this.params.addressId)
          //     return item.userAddressId === this.params.addressId
          //   })
          //   console.log(address, this.params.addressId)
          //   if (!address) {
          //     this.params.addressId = ''
          //     this.refushOrder()
          //   }
          // }
          // this.payInvoiceInfoList = data.payInvoiceInfoVoList || []
          // this.params.addressId = addressId
          this.dataJson = data
          if (data.payOrderItemVoList && data.payOrderItemVoList.length) {
            this.distributionFlag = data.payOrderItemVoList.every(item => {
              // distribution  =2支持  =1 不支持 3面议
              return item.distribution && item.distribution !== 1
            })
          } else {
            this.distributionFlag = false
          }
        })
    },
    // 关闭弹窗  地址
    handleClose2 () {
      this.editAddressVisible = false
      this.editAddressInfo = {
        companyId: '', // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
    },
    // 添加地址
    addAddress () {
      this.editAddressInfo = {
        companyId: this.params.companyId, // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
      this.editAddressVisible = true
    },
    // 编辑地址
    addressEditHandle (row) {
      this.editAddressInfo = {
        companyId: row.companyId, // 当前地址对应的公司Id
        userAddressId: row.userAddressId,
        proCityArea: [],
        address: row.address, // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: row.receiveGoodsPerson, // 收货人
        receiveGoodsPhone: row.receiveGoodsPhone, // 收货联系电话
        defaultAddress: row.defaultAddress, // 是否默认地址
        used: row.used // 是否可用
      }
      if (row.province) {
        this.editAddressInfo.proCityArea.push(row.province)
        if (row.city) {
          this.editAddressInfo.proCityArea.push(row.city)
          if (row.area) {
            this.editAddressInfo.proCityArea.push(row.area)
          }
        }
      }
      this.editAddressVisible = true
    },
    // 保存地址
    handleAddressSaved: debounce(function () {
      this.$refs['editAddressInfo'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.editAddressInfo.province = this.editAddressInfo.proCityArea[0]
        this.editAddressInfo.city = this.editAddressInfo.proCityArea[1]
        this.editAddressInfo.area = this.editAddressInfo.proCityArea[2]
        this.editAddressInfo.orderAddress = this.editAddressInfo.proCityArea.join('') + this.editAddressInfo.address
        this.$http.post(`/front/consumer/user/address/${this.editAddressInfo.userAddressId ? 'updateUserAddress' : 'addUserAddress'}`, this.editAddressInfo)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success(res.message)
            this.handleClose2()
            this.getaddressDataList()
            // this.editAddressVisible = false
          }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 删除地址
    addressDeleteHandle (row) {
      this.addressDeleteId = row.userAddressId
      this.addressDeleteVisible = true
    },
    // 确认删除地址
    confirmAddDelete () {
      if (!this.addressDeleteId) {
        this.addressDeleteVisible = false
        return false
      }
      this.$http.post(`/front/consumer/user/address/deleteById/${this.addressDeleteId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.addressDeleteVisible = false
          this.getaddressDataList()
        })
    },
    // 获取用户地址列表
    getaddressDataList () {
      this.$request.get(`/front/consumer/user/address/userAddressList?companyId=${this.params.companyId}`)
        .then(res => {
          this.addressList = res || []
          if (this.params.addressId) {
            let address = this.addressList.find(item => {
              return item.userAddressId === this.params.addressId
            })
            if (!address) {
              this.params.addressId = ''
            }
          }
          if ((!this.params.addressId) && this.addressList.length) {
            let address = this.addressList.find(item => {
              return item.defaultAddress === true
            })
            if (address) {
              this.params.addressId = address.userAddressId
            } else {
              this.params.addressId = this.addressList[0].userAddressId
              this.addressChangeHandle(this.addressList[0].userAddressId)
            }
          }
        })
        .catch()
    },
    // 新增发票
    invoiceAddHandle () {
      this.invoiceVisible = true
      if (this.$refs['invoiceForm']) {
        this.$refs['invoiceForm'].resetFields()
      }
      this.invoiceForm = {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '10', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      }
    },
    // 编辑发票
    invoiceEditHandle (row) {
      this.invoiceVisible = true
      if (this.$refs['invoiceForm']) {
        this.$refs['invoiceForm'].resetFields()
      }
      this.invoiceForm = {
        flagAdd: row.defaultFlag === '10',
        invoiceId: row.invoiceId,
        invoiceObjType: row.invoiceObjType, // 开票对象类型 10 个人 20 单位
        invoiceObjId: row.invoiceObjId, // 开票对象10 用户id 20 公司id
        invoiceType: row.invoiceType, // 开票类型10 普通发票 20 增值税发票
        companyName: row.companyName, // 开票公司名称(发票抬头)
        taxpayerIdentity: row.taxpayerIdentity, // 纳税人识别号
        companyAddress: row.companyAddress, // 公司地址
        companyPhone: row.companyPhone, // 联系电话
        openingBank: row.openingBank, // 开户行
        bankAccountNo: row.bankAccountNo, // 开户行账号
        defaultFlag: row.defaultFlag, //  缺省标识 10 默认 20 非默认
        remarks: row.remarks,
        mailingAddress: row.mailingAddress, // 发票邮寄地址
        consignee: row.consignee, // 收货人
        contactInformation: row.contactInformation // 收货人联系方式
      }
    },
    // 删除发票
    invoiceDeleteHandle (row) {
      this.$confirm('此操作将永久删除该发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$http.post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.getInvoicList()
          })
      }).catch(() => {
      })
    },
    // 关闭发票
    closeInviceHandle () {
      this.invoiceVisible = false
      this.$refs['invoiceForm'].resetFields()
    },
    // 保存发票
    invoiceSaveHandle: debounce(function () {
      this.$refs['invoiceForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.invoiceForm.invoiceObjType === '10') {
          this.invoiceForm.invoiceObjId = ''
        } else {
          this.invoiceForm.invoiceObjId = this.companyId
        }
        this.invoiceForm.companyId = this.companyId
        this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '10' : '20'
        this.$http.post(`/front/consumer/order/payinvoice/${this.invoiceForm.invoiceId ? 'update' : 'save'}`, this.invoiceForm)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success(res.message)
            this.closeInviceHandle()
            this.getInvoicList()
          }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 获取发票列表
    getInvoicList () {
      this.$request.get(`/front/consumer/order/payinvoice/getUserAllInvoiceList?companyId=${this.companyId}`)
        .then(res => {
          this.payInvoiceInfoList = res || []
          if (this.dataForm.invoiceInfoId) {
            let invoiceInfo = this.payInvoiceInfoList.find(item => {
              return item.invoiceId === this.dataForm.invoiceInfoId
            })
            if (!invoiceInfo) {
              this.dataForm.invoiceInfoId = ''
            }
          }
          if ((!this.dataForm.invoiceInfoId) && this.payInvoiceInfoList.length) {
            let invoiceInfo = this.payInvoiceInfoList.find(item => {
              return item.defaultFlag === '10'
            })
            if (invoiceInfo) {
              this.dataForm.invoiceInfoId = invoiceInfo.invoiceId
            } else {
              this.dataForm.invoiceInfoId = ''
              // this.payInvoiceInfoList[0].invoiceId
            }
          }
        })
        .catch()
    },
    // 提交订单
    submit: debounce(function () {
      // if (!this.$store.state.user.defaultCompanyId) {
      //   this.$confirm(
      //     '个人用户暂不支持下单请先升级为企业客户',
      //     '温馨提示',
      //     {
      //       dangerouslyUseHTMLString: true,
      //       confirmButtonText: '升级为企业客户',
      //       cancelButtonText: '取消'
      //     }
      //   )
      //     .then(() => {
      //       this.addCompanyVisible = true
      //       this.$nextTick(() => {
      //         this.$refs.companyAdd.init()
      //       })
      //     })
      //   return false
      // }
      if (!this.params.addressId) {
        this.$message.error('请选择地址')
        return
      }
      if (!this.params.addressId) {
        this.$message.error('请选择地址')
        return
      }
      if (this.buttonLoading) {
        return false
      }
      if (this.dataForm.contractType === '10') {
        // 自行上传合同
        if (!this.dataForm.contractUrl) {
          this.$message.warning('请上传合同')
          return false
        }
      } else {
        this.dataForm.contractUrl = ''
      }
      this.buttonLoading = true
      this.$http.post(`/front/consumer/order/saveOrder`, {
        ...this.dataForm,
        contractUrl: this.dataForm.contractUrl ? [this.dataForm.contractUrl] : [],
        ...this.params
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          } else {
            this.$router.replace({
              name: 'orderDetail',
              params: {
                id: res.data
              }
            })
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 查看合同
    lookContract () {
      if (!this.params.addressId) {
        this.$message.warning('请选择地址')
        return false
      }
      let goodsNum = ''
      let goodsskuId = ''
      let goodsspuId = ''
      if (this.params.orderSource === '10') { // 购物车
        goodsNum = this.params.shoppingCartFormList.map(item => {
          return item.goodsNum
        }).join()
        goodsskuId = this.params.shoppingCartFormList.map(item => {
          return item.goodsSkuId
        }).join()
        goodsspuId = this.params.shoppingCartFormList.map(item => {
          return item.goodsSpuId
        }).join()
      } else if (this.params.orderSource === '20') {
        goodsNum = this.params.shoppingCart.goodsNum
        goodsskuId = this.params.shoppingCart.goodsSkuId
        goodsspuId = this.params.shoppingCart.goodsSpuId
      }
      openOther(
        `orderContract?invoiceId=${this.dataForm.invoiceInfoId}&goodsNum=${goodsNum}&goodsskuId=${goodsskuId}&goodsspuId=${goodsspuId}&sourceId=${this.sourceId}&orderSource=${this.params.orderSource}&addressId=${this.params.addressId}&currentRow=${this.dataForm.invoiceInfoId}`
      )
      // this.payType === '10' 先付款
    },
    // 合同下载
    contractDownloadHandle () {
      if (!this.params.addressId) {
        this.$message.warning('请选择地址')
        return false
      }
      let params = {
        source: 2,
        userId: this.params.userId,
        userAddressId: this.params.addressId,
        invoiceId: this.dataForm.invoiceInfoId,
        commodityIds: ''
      }
      if (this.params.orderSource === '10') { // 购物车
        params.commodityIds = this.params.shoppingCartFormList.map(item => {
          return item.goodsSkuId + '$' + item.goodsNum
        }).join()
      } else if (this.params.orderSource === '20') {
        params.commodityIds = this.params.shoppingCart.goodsSkuId + '$' + this.params.shoppingCart.goodsNum
      }
      window.open(`${window.SITE_CONFIG['apiURL']}/front/consumer/order/orderContractDownload?${qs.stringify(params)}`)
    },
    // 校验图片格式
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 8
      var reg = /\.(jpg|bmp|gif|jpeg|png|pdf|doc|docx)$/
      const isJPG = reg.test(type)
      if (!isJPG) {
        this.$message.error('上传文件只能是 jpg|bmp|gif|jpeg|png|pdf|doc|docx 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 8MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      return isJPG && isLt2M
    },
    beforeRemove (file) {
      if (file.response) {
        this.contractIds.push(file.response.data.aliOssId)
      }
      this.dataForm.contractUrl = ''
      // this.$request.get(`help/fileupload/sys/deleteBatchAliOss`, [])
    },
    handleSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.dataForm.contractUrl = res.data.url
        // this.IdcardBackUrl = res.data.url
        // this.IdcardBackId = res.data.aliOssId
      } else {
        this.dataForm.contractUrl = ''
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    // 获取省
    getProvince () {
      this.$http
        .get(`/front/sys/sysProvince/provinceList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.region = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取省份失败')
        })
    },
    // 获取市
    getCity (codeP) {
      return this.$http
        .get(`/front/sys/sysProvince/cityList/${codeP}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            return res.data
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取城市失败')
        })
    },
    // 获取区
    getArea (codeC) {
      return this.$http
        .get(`/front/sys/sysProvince/areaList/${codeC}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const leafData = res.data.map((item) => {
              return {
                ...item,
                leaf: true
              }
            })
            return leafData
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取区域失败')
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.create_order{
  background: #fff;
  padding: 30px;
  .order_body{
    width: 907px;
    margin: 0 auto;
    .margin-top{
      margin-top: 20px;
    }
    .left-margin{
      margin-left: 30px;
    }
    /deep/ input[type="radio" ] {
      width: 14px;
      height: 14px;
      background: #fff;
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 1px solid #dcdfe6;
      margin-right:10px;
      cursor:pointer;
    }
    /deep/input[type="radio" ]:checked {
        background:url("./../../../assets/img/order/selecta.png");
        background-size: cover;
        border:none;
    }
    /deep/ input[type="radio" ]:disabled {
        background-color:#ebebeb;
        cursor: default;
    }
    .addBut{
      display: inline-block;
      width: 130px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #1d65a8;
      color: #1d65a8;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      user-select: none;
      cursor: pointer;
      z-index: 666;
    }
    .addressList_oreder{
      padding-top: 20px;
      .addTitle {
        width: 906px;
        height: 40px;
        display: flex;
        .addTitle1 {
          flex: 1;
          font-size: 16px;
          color: #666666;
          line-height: 44px;
        }
        .addTitle2 {
          width: 130px;
          height: 40px;
          box-sizing: border-box;
          border: 1px solid #1d65a8;
          color: #1d65a8;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          user-select: none;
          cursor: pointer;
          z-index: 666;
        }
      }
    }
    .downloadContract{
      padding-left: 80px;
      margin-top: 15px;
      .checkContract {
        margin-right: 20px;
        height: 36px;
        line-height: 36px;
        color: #1d65a8;
        cursor: pointer;
      }
    }
    .invoice_order{}
    .discount {
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .not-in-distribution{
      width: 320px;
      padding: 9px 43px;
      line-height: 22px;
      border: none;
      color: #fff;
      margin: 0 auto;
      cursor: not-allowed;
      background: #eee;
      color: #999;
    }
    .save-but{
      background: #1d65a8;
      width: 320px;
      padding: 9px 43px;
      line-height: 22px;
      border: none;
      color: #fff;
      margin: 0 auto;
      cursor: pointer;
    }
    .deliveryArea{
      display: inline-block;
      border: 1px solid red;
      padding: 3px 5px;
      border-radius: 10px;
      color: red;
    }
    .default-flag{
      display: inline-block;
      width: 35px;
      height: 20px;
      line-height: 20px;
      background: #1d65a8;
      color: #ffffff;
      font-weight: normal;
      font-size: 12px;
      text-align: center;
      margin-left: 20px;
    }
  }
  .last_row{
    display: flex;
    justify-content: space-between;
    font-size: 20px;
  }
}
.addArea {
  width: 1100px;
  // height: 506px;
  background: #ffffff;
  padding-left: 23px;
  padding-right: 42px;
  .addTitle {
    height: 80px;
    line-height: 80px;
    font-size: 22px;
    color: #333333;
    text-indent: 8px;
    border-bottom: 1px solid #eeeeee;
  }
  .add_form{
    .input_width{
      width: 250px;
    }
    .last_row{
      display: flex;
      justify-content: space-between;
    }
    .saveAdd{
      width: 150px;
      height: 40px;
      background: #1D65A8;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 30px;
      margin-left: 859px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
}
</style>
